import React, { Component } from 'react'
import {
  TYPE_INPUT_TEXT,
  TYPE_INPUT_NUMBER,
  TYPE_INPUT_TEXTAREA,
  TYPE_INPUT_BOOLEAN,
  TYPE_INPUT_DATE,
  TYPE_INPUT_FILE,
  TYPE_LIST,
  TYPE_MULTIPLE,
} from 'helpers/logbook'
import TextInput from './EventResultTextInput'
import NumberInput from './EventResultNumberInput'
import TextareaInput from './EventResultTextareaInput'
import BooleanInput from './EventResultBooleanInput'
import DateInput from './EventResultDateInput'
import FileInput from './EventResultFileInput'
import List from './EventResultList'
import MultipleList from './EventResultMultipleList'

class EventField extends Component {
  onValueChange = data => {
    const { onEventValueChange } = this.props

    if (typeof onEventValueChange === 'function') {
      onEventValueChange(data)
    }
  }

  getInputProps = () => {
    const { eventInfo, disabled, index: initIndex } = this.props
    const { options } = eventInfo
    const index = Number(initIndex)

    return {
      eventInfo,
      disabled,
      options,
      dataIndex: index,
      tabIndex: 100 + index,
      onValueChange: this.onValueChange,
    }
  }

  render() {
    const inputList = {
      [TYPE_INPUT_TEXT]: TextInput,
      [TYPE_INPUT_NUMBER]: NumberInput,
      [TYPE_INPUT_TEXTAREA]: TextareaInput,
      [TYPE_INPUT_BOOLEAN]: BooleanInput,
      [TYPE_INPUT_DATE]: DateInput,
      [TYPE_INPUT_FILE]: FileInput,
      [TYPE_LIST]: List,
      [TYPE_MULTIPLE]: MultipleList,
    }
    const { type } = this.props.eventInfo
    const Input = inputList[type]

    if (!Input) {
      return null
    }

    return <Input {...this.getInputProps()} />
  }
}

export default EventField
